import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApiError } from "go-core/api/types";
import { FormErrorMessageApi } from "go-form/components/FormErrorMessage";
import { CustomValidationConfig, CustomValidationConstraint, CustomValidationError } from "go-form/services/types";
import { PayOrderData } from "../../../../../../../services/Api/Public/types";

interface Props {
	form: UseFormReturn<PayOrderData>;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<PayOrderData>[]>>;
	customFormErrors: ApiError[];
}

const OrderPaymentEmailInput = ({ form, setErrors, customFormErrors }: Props) => {
	const {
		register,
		formState: { errors },
		watch,
	} = form;
	const validationConfig = useMemo(
		() => ({
			types: [{ constraint: CustomValidationConstraint.REQUIRED }],
			setErrors,
			utils: { watch },
		}),
		[setErrors, watch]
	) satisfies CustomValidationConfig;
	const { t } = useTranslation();

	return (
		<div className="mt-3">
			<>
				<FormInput
					name="email"
					errors={errors}
					register={register}
					customValidationConfig={validationConfig}
					placeholder={t("lib:common.word.email")}
					firstInput
				/>
				{customFormErrors.length > 0 && <FormErrorMessageApi errors={customFormErrors} field="email" />}
			</>
		</div>
	);
};

export default OrderPaymentEmailInput;
